export default {
    'name': 'plus',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M12.7929 2.25C12.9228 2.41871 13 2.63003 13 2.85938V11H21.1406C21.37 11 21.5813 11.0772 21.75 11.2071V12.7929C21.5813 12.9228 21.37 13 21.1406 13H13V21.1406C13 21.37 12.9228 21.5813 12.7929 21.75H11.2071C11.0772 21.5813 11 21.37 11 21.1406V13H2.85938C2.63003 13 2.41871 12.9228 2.25 12.7929V11.2071C2.41871 11.0772 2.63003 11 2.85938 11H11V2.85938C11 2.63003 11.0772 2.41871 11.2071 2.25H12.7929Z\' fill=\'#FF4171\'/>'
}
